import { PageRouteBuilder } from "@common/route/page-route-builder";
import { AuthAuditPageComponent } from "./auth-audit-page.component";

export const authAuditPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-auth-audit-page", AuthAuditPageComponent)
    .requiresLogin()
    .atUrl("/tools/auth-audit")
    .withTitle("Auth Audit")
    .build();
